/**
 * Design-tab values that genuinely have to be *derived* in JS, same reasoning as `layoutCssVars.ts`: the widget
 * runs on the NoCss/CSS-optimized path, where a style change only recomputes CSS vars and never re-renders the
 * React component, so anything derived in JS from a style param and applied as an inline style stays stale.
 *
 * Keep this file minimal. Raw style params do NOT belong here - the platform already publishes every param as a
 * CSS var under its own key (`--<colorParam>`, `--<numberParam>` as a unitless number, and `--<fontParam>-family`
 * / `-size` / `-style` / `-weight` / `-line-height` / `-text-decoration`), and those are live without any JS.
 * Read them straight from `.st.css` instead; only genuinely computed values (a boolean mapped to a CSS keyword,
 * a value combined from several params) need to go through `customCssVars`.
 */
export const getMenuAddOnDesignCssVars = ({
  booleans,
}: {
  booleans: Record<string, unknown>;
}): Record<string, string> => {
  const showTitle = booleans.showMenuName !== false;
  const showSubtitle = booleans.showMenuDescription !== false;

  return {
    menuAddOnDesignHeaderDisplay: showTitle || showSubtitle ? 'flex' : 'none',
    menuAddOnDesignTitleDisplay: showTitle ? 'block' : 'none',
    menuAddOnDesignSubtitleDisplay: showSubtitle ? 'block' : 'none',

    // Ordering banner icon visibility: a Boolean param has no CSS-keyword equivalent to read directly.
    menuAddOnOrderingBannerIconDisplay: booleans.menuAddOnOrderingBannerShowIcon === false ? 'none' : 'inline-flex',
  };
};
